<template>
  <td class="responsive-table__td responsive-td" :class="{'responsive-table__td_mobile-hidden': mobileNoShow}">
    <div class="responsive-td__content" :style="{minWidth: minWidth}">
      <div v-html="th" class="responsive-table__mobile-header" v-if="!noHeaderMobile"
           :style="{width: mobileHeaderWidth !== null ? mobileHeaderWidth + 'px' : 'auto'}" />
      <span class="responsive-td__content-text">
        <slot />
      </span>
    </div>
  </td>
</template>

<script>

const findParent = ( $el, componentName ) => {
  while ($el) {
    if ($el.$vnode.componentOptions.tag === componentName) return $el;
    $el = $el.$parent;
  }
  return null;
};

export default {
  name:  "RtTd",
  props: {
    mobileHeaderWidth: {
      default: null,
    },
    noHeaderMobile:    {
      default: false,
      type:    Boolean,
    },
    mobileNoShow:      {
      default: false,
      type:    Boolean,
    },
    mobileHeaderText:  {
      default: "",
      type:    String,
    },
    minWidth:          {
      default: "120px",
    },
  },
  data() {
    return {
      th: "",
    };
  },
  mounted() {
    if (this.mobileHeaderText.length) {
      this.th = this.mobileHeaderText;
    } else {
      let row = findParent(this, 'rt-tr');
      let table = findParent(row, 'rt-table');
      let index = row.$children.findIndex(td => td === this);
      let ths = table.$refs.thead.querySelectorAll('.responsive-table__th');
      this.th = ths[index].querySelector('.responsive-th__content').innerHTML;
    }
  },
};
</script>

<style lang="scss">
.responsive-td {
  padding: 0;

  &__content {
    color: #47404f;
    border-bottom: 0 solid #dcdfe6;
    min-width: 140px;
    font-size: 1rem;
    padding: 10px 12px;
    vertical-align: middle;
  }
}
</style>
